import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  padding: 10px 0 0 0;
  pointer-events: auto;
  user-select: auto;
`;
